import { sections } from "@/configs/discover";
import { DatasetCard } from "@/features/dataset";
import { useTranslation } from "@/hooks";
import type { Topic } from "@/types/discover";
import { Flex, Group, Image, Text } from "@mantine/core";
import { useCallback, useEffect, useState } from "react";

export function DiscoverFeed({ sectionId }: { sectionId: string }) {
  const { t } = useTranslation();
  const section = sections.find((s) => s.id === sectionId);
  const [topics, setTopics] = useState<Topic[]>([]);

  const fetchTopics = useCallback(() => {
    setTopics([]);
  }, [sectionId]);

  useEffect(fetchTopics, [sectionId]);

  const SectionIcon = section?.icon;

  const getSectionIcon = (topic: Topic) => {
    if (topic.icon) {
      if (typeof topic.icon === "string") {
        return (
          <Image
            style={{ objectFit: "contain", width: 28, height: 18 }}
            src={topic.icon}
          />
        );
      }
      const Icon = topic.icon;
      return <Icon />;
    }
    return null;
  };

  return (
    <Flex flex={1} h="100%" direction="column" gap="xl">
      <Group gap="sm" align="center">
        {SectionIcon && (
          <SectionIcon
            stroke={1.6}
            color="var(--mantine-color-eu_flag-filled)"
            size={32}
          />
        )}
        <Text fz={28} fw={600}>
          {section?.title ?? t("discover").exploreTopics}
        </Text>
      </Group>
      {topics.map((topic: Topic) => {
        const sectionIcon = getSectionIcon(topic);
        return (
          <Flex
            key={topic.id}
            direction="column"
            gap="xl"
            mb={80}
            w="100%"
            maw={620}
          >
            <Flex
              direction="column"
              gap={50}
              w="100%"
              h={120}
              align="flex-start"
              justify="flex-end"
              py="md"
              px="lg"
              bdrs="sm"
              pos="relative"
              style={{
                overflow: "hidden",
              }}
            >
              <Image
                src={topic.image}
                alt={topic.title}
                width={100}
                height={100}
                style={{
                  objectFit: "cover",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  zIndex: -1,
                }}
              />
              <Flex
                align="center"
                gap={10}
                justify="center"
                style={{ flexShrink: 0 }}
              >
                {sectionIcon}
                <Text c="white" fz={20} fw={600}>
                  {topic.title}
                </Text>
              </Flex>
            </Flex>
            <Flex direction="column" gap="md">
              {topic.datasets.map((dataset) => (
                <DatasetCard key={dataset.db_table_id} dataset={dataset} />
              ))}
            </Flex>
          </Flex>
        );
      })}
    </Flex>
  );
}
